import { Trans, useTranslation } from "react-i18next";
import ContentHeading from "../content-heading";
import { IInvestorSection } from "./interfaces/IInvestorSection";
// Tailwind CSS
import {
  evenBlock,
  oddBlock,
  content,
  image,
  strong,
  p,
  linkedin,
} from "./styles/investor-section-item";
import {
  wrapper,
  evenContainer,
  oddContainer,
} from "./styles/investor-section";
import CustomLink from "@/components/custom-link";
import { PromoEaster } from "../promo-easter/promo-easter";
import classNames from "classnames";

const InvestorSection: React.FC<IInvestorSection> = ({
  investorType,
  investors,
  isDark,
  isEven,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <section
      className={classNames(wrapper(isDark), "relative")}
      title={t(`who-we-are.${investorType}.seo.title`)}
      aria-label={t(`who-we-are.${investorType}.seo.aria-label`)}
    >
      {children}
      <ContentHeading
        h="p"
        className="justify-center"
        backdropPosition="left-4"
        fontSize="mobile:text-3xl tablet:text-4xl"
        background="bg-primary bg-opacity-40"
        color={isDark ? "text-white" : "text-secondary"}
      >
        {t(`who-we-are.${investorType}.heading`)}
      </ContentHeading>
      <div className={isEven ? evenContainer : oddContainer}>
        {investors.map(
          (
            item: {
              name: string;
              linkedIn: string;
              title: string;
              alt: string;
            },
            index: number
          ) => {
            const directorName = item.name.replace(/\s/g, "-");
            return (
              <div
                className={isEven ? evenBlock(isDark) : oddBlock(isDark)}
                key={index}
              >
                <img
                  title={item.title}
                  alt={item.alt}
                  className={image(isDark)}
                  srcSet={`
									/assets/images/pages/who-we-are/${directorName}/small.webp 64w,
									/assets/images/pages/who-we-are/${directorName}/small.png 64w,
									/assets/images/pages/who-we-are/${directorName}/medium.webp 129w,
									/assets/images/pages/who-we-are/${directorName}/medium.png 129w,
									/assets/images/pages/who-we-are/${directorName}/large.webp 258w,
									/assets/images/pages/who-we-are/${directorName}/large.png 258w,
								`}
                  sizes="(max-width:736px) 64px, (max-width:1280px) 129px, 258px"
                  src={`/assets/images/pages/who-we-are/${directorName}/small.png`}
                />
                <div className={content(isDark)}>
                  <CustomLink
                    url={item.linkedIn}
                    className={`flex items-start ${
                      isDark ? "mobile:justify-start" : "mobile:justify-center"
                    } tablet:justify-start`}
                  >
                    <strong className={strong}>{item.name}</strong>
                    {item.linkedIn !== "" && (
                      <img
                        className={linkedin}
                        src={"/assets/icons/linked-in.png"}
                        alt={"LinkedIn Logo"}
                      />
                    )}
                  </CustomLink>

                  <p className={p}>
                    <Trans components={{ br: <br /> }}>
                      who-we-are.{investorType}.{item.name}
                    </Trans>
                  </p>
                </div>
              </div>
            );
          }
        )}
      </div>
    </section>
  );
};

export default InvestorSection;
